import React, { useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { useIngredient } from '../contexts/IngredientContext';
import { CFormLabel } from '@coreui/react';

function IngredientSelection({ value, onChange, className, labelClassName, multiSelect = true, required = false, error = false, disabled = false }) {
    const requiredIcon = required ? <span className="text-danger">*</span> : null;

    const { getAllIngredients } = useIngredient();

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    const fetchIngredient = async (searchValue, loadedOptions, { page }) => {
        try {
            const response = await getAllIngredients(page, rowsPerPage, 'id', -1, searchValue);

            if (response.totalPages > 0) {
                const newOptions = response.data.map((ingredient) => ({
                    label: ingredient.name,
                    value: ingredient.id,
                    unit: ingredient.unit
                }));

                return {
                    options: newOptions,
                    hasMore: page !== response.totalPages,
                    additional: {
                        page: page + 1,
                    },
                };
            } else {
                return {
                    options: [],
                    hasMore: false,
                    additional: null,
                };
            }
        } catch (error) {
            console.error('Error fetching ingredients', error);
            return {
                options: [],
                hasMore: false,
                additional: null,
            };
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            whiteSpace: state.isFocused ? 'pre-wrap' : 'nowrap',
            wordBreak: state.isFocused ? 'break-all' : null,
            wordWrap: state.isFocused ? 'break-word' : null,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }),
    };

    return (
        <div className={className}>
            <div className={labelClassName}>
                <CFormLabel>Ingredient {requiredIcon}</CFormLabel>
            </div>
            <div className='w-100'>
                <AsyncPaginate
                    className={`${(error && required) && 'multiSelect_error'}`}
                    value={value}
                    loadOptions={fetchIngredient}
                    isMulti={multiSelect}
                    closeMenuOnSelect={!multiSelect ? true : false}
                    onChange={onChange}
                    isDisabled={disabled}
                    placeholder='Select ingredients...'
                    noOptionsMessage={() => ('No ingredients found')}
                    loadingMessage={() => ('Ingredients Loading...')}
                    additional={{
                        page: currentPage,
                    }}
                    SelectProps={{
                        isSearchable: true
                    }}
                    menuShouldScrollIntoView={false}
                    menuPortalTarget={document.querySelector('body')}
                    styles={customStyles}
                />
                {(error && required) && <span className="text-danger error_message">Please select any one ingredient.</span>}
            </div>
        </div>
    );
}

export default IngredientSelection